module.exports = __webpack_public_path__ + "img/HAPPE_120X35.b4d50542.png";